module.exports = __webpack_public_path__ + "static/media/paypal.2db22c6c.svg";